export const VITE_PRELOAD_ERROR_RELOAD_KEY =
  'personallm-admin:vite-preload-error-reloaded';

interface PreloadErrorRecoveryTarget {
  addEventListener: Window['addEventListener'];
  removeEventListener: Window['removeEventListener'];
  location: Pick<Location, 'reload'>;
  sessionStorage?: Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;
}

function storageFor(target: PreloadErrorRecoveryTarget) {
  try {
    return target.sessionStorage ?? null;
  } catch {
    return null;
  }
}

export function clearVitePreloadErrorReloadGuard(
  target: PreloadErrorRecoveryTarget = window
) {
  const storage = storageFor(target);
  if (!storage) return;

  try {
    storage.removeItem(VITE_PRELOAD_ERROR_RELOAD_KEY);
  } catch {
    // If storage is unavailable, leave recovery to the route error boundary.
  }
}

export function installVitePreloadErrorRecovery(
  target: PreloadErrorRecoveryTarget = window
) {
  const handlePreloadError = (event: Event) => {
    const storage = storageFor(target);
    if (!storage) return;

    try {
      if (storage.getItem(VITE_PRELOAD_ERROR_RELOAD_KEY)) return;
      storage.setItem(VITE_PRELOAD_ERROR_RELOAD_KEY, '1');
      event.preventDefault();
      target.location.reload();
    } catch {
      // If the guard cannot be written, do not reload-loop.
    }
  };

  target.addEventListener('vite:preloadError', handlePreloadError);

  return () => {
    target.removeEventListener('vite:preloadError', handlePreloadError);
  };
}
